import { useNavigate } from 'react-router-dom';
import { ShieldX } from 'lucide-react';
import { AuthLayout } from '@/components/layout/AuthLayout';
import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { authService } from '@/services/auth.service';
import { useAuthStore } from '@/stores/auth.store';

export function AccountBlockedPage() {
  const navigate = useNavigate();
  const logout = useAuthStore((s) => s.logout);

  async function handleSignOut() {
    try {
      await authService.logout();
    } catch {
      // Ignore logout errors
    }
    logout();
    navigate('/login', { replace: true });
  }

  return (
    <AuthLayout>
      <Card className="border-0 border-l-4 border-l-red-500 bg-white/80 shadow-lg shadow-purple-500/5 backdrop-blur-sm dark:bg-card/80 rounded-xl">
        <CardContent className="flex flex-col items-center p-6 sm:p-8 text-center">
          <div className="mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-red-100 dark:bg-red-900/30">
            <ShieldX className="h-8 w-8 text-red-600 dark:text-red-400" />
          </div>
          <h2 className="text-xl font-bold text-foreground">Account Blocked</h2>
          <p className="mt-2 max-w-sm text-sm text-muted-foreground">
            Your account has been restricted by an administrator. If you believe this is an error,
            please contact your organization&apos;s administrator for assistance.
          </p>
          <Button
            variant="outline"
            className="mt-6"
            onClick={handleSignOut}
          >
            Sign Out
          </Button>
        </CardContent>
      </Card>
    </AuthLayout>
  );
}
